import { ManagerType } from "../../../types/Manager";
import { put } from "../../../utils/axios-config";
import { MANAGERS } from "../../../utils/constants";

export const updateManager = async (data: ManagerType) => await put<ManagerType, string>(MANAGERS, data);